import React from "react";
import "./ActivatorIcons.css";

function ActivatorIcons({
  onToolbarToggle,
  onChatbotToggle,
  dashboardVisible,
  onDashboardToggle,
}) {
  return (
    <>
      <button
        id="toolbar-activator"
        className="activator-icon"
        title="Drawing Tools"
        onClick={onToolbarToggle}
      >
        <i className="fa-solid fa-pen-ruler"></i>
      </button>
      <button
        id="chatbot-activator"
        className="activator-icon"
        title="AI Assistant"
        onClick={onChatbotToggle}
      >
        <i className="fa-solid fa-robot"></i>
      </button>
      {dashboardVisible && (
        <button
          id="dashboard-activator"
          className="activator-icon"
          title="Analysis Dashboard"
          onClick={onDashboardToggle}
          style={{ left: "100px" }}
        >
          <i className="fa-solid fa-chart-pie"></i>
        </button>
      )}
    </>
  );
}

export default ActivatorIcons;
